var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"background-picture",class:{ step1: _vm.step === 1, step2: _vm.step === 2, step3: _vm.step === 3},on:{"click":_vm.onClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }